<template>
  <!-- 聊天记录 -->
  <!-- <div style="display: flex"> -->
  <div class="history-reacd" v-if="navSelctType == 0&&searchedData.length">
      <div class="h-38 l-h-38 p-l-16 f-s-12" style="color: #999999;border-bottom: 1px solid #f2f2f2" v-if="navSelctType == 0&&searchedData.length">聊天记录</div>
      <template v-else-if="!keyWord">
        <div class="t-a-center" style="margin: 68px auto auto;">
          <img src="@/assets/images/im/kong-order@2x.png" width="155px" height="104px"/>
        </div>
        <div class="f-s-12 t-a-center" style="color:#999999">输入关键字开始搜索</div>
      </template>
      <ul>
          <li class="flex cursor-pointer bg-g-50-hover" v-for="(item,index) in searchedData" :key="index" v-if="(navSelctType == 0 && 3 > index)" @click="viewDetail(item)">
              <div class="d-table-cell v-a-middle h-100-p w-64" style="text-align: center;">
                  <span v-if="item.convType=='PERSON'&&item.fromAccount.length==32" class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname(item.fromNick||item.fromAccount)}}</span>
                  <img src="@/assets/images/im/kefu.svg" v-if="item.convType=='PERSON'&&item.fromAccount.length<32"  style="width:40px;height:40px;"/>
                  <img  v-if="item.convType=='TEAM'" src="@/assets/images/im/team-cus.png" style="width:40px;height:40px;"/>
              </div>
              <div class="content" :style="{width:listWidth+'px'}">
                <div class="flex header">
                    <div class="w-s-nowrap t-o-ellipsis o-hidden f-s-12">{{item.fromNick||item.fromAccount}} > {{item.toNick||item.to}}</div>
                    <!--<div>{{format(item.time,0)}}</div>-->
                </div>
                <div class="m-r-4 w-s-nowrap t-o-ellipsis o-hidden" v-html="item.html"></div>
              </div>
          </li>
      </ul>
      <div class="h-36 l-h-36 p-l-16 p-r-12 flex justify-content-between align-items-center cursor-pointer" style="color: #653EB3;border-bottom: 1px solid #f2f2f2;" v-if="hasMore" @click="selectedHistoryRecord">
        <span class="d-block">查看更多相关聊天记录</span><img src="@/assets/images/im/arrow-right@2x.png" class="d-block" style="width: 8px;height:14px"/>
      </div>
  </div>
  <!-- </div> -->
</template>
<script>
import emoticonArr from './util/emoticon.js';
export default {
  name:"imHistoryRecord",
  props: {
    // im实例
    im: {
        type: Object,
        default: function () {
          return {};
        }
    },
    hasMore:{
      type: Boolean,
      default: false
    },
    historyRecord:{
        type: Array,
        default: []
    },
    keyWord:{
        type: String,
        default: ""
    },
    navSelctType:{
      type: String,
      default: "0"
    },
    width: {
      type: Number,
      default: 164
    },
  },
  data: function () {
    return {
        listWidth: 164,
        emoticonArr,
        historyRecordData:[],
        recordDetail:[],
        showDetail: false,
        teamName: "",
        noData: false,//没有搜索到数据
        orgType:[0,0],//orgType[0]=1有个人，orgType[1]=1，有群聊
        setToNameFlag:[0,0],
        searchedData:[]
    };
  },
  mounted: function(){
  },
  methods: {
    // 处理表情符号
    iconhandler: function (text) {
      var $this = this,
        arrStore = [];
      text.replace(/\[([^\[]+)\]/g, function (str) {
        arrStore.push(str);
      });
      arrStore.forEach(function (element) {
        var index = text.indexOf(element),
          len = element.length,
          name = element.replace(/\[|\]/g, ''),
          src = '';
        for (var i = 0; i < $this.emoticonArr.length; i++) {
          if ($this.emoticonArr[i].name === name) {
            src = $this.emoticonArr[i].src;
            break;
          }
        }
        if (src) {
          var str = text.substring(0, index);
          str += '<img src="' + src + '"   width="20">';
          str += text.substring(index + len);
          text = str;
        }
      });
      return text;
    },
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    group: function (arr) {
      let $this = this;
      $this.searchedData = [];
      arr.forEach(function (item) {
          if(item.body){
          item.body = $this.iconhandler(item.body);
          item.originalHtml = item.body.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#760EA4">$1</span>');
          let text = item.body,
            index = text.indexOf($this.keyWord),
            radius = 6;
          text = text.substr(index >= radius ? (index - radius) : 0);
          if (index > radius) {
            text = '...' + text;
          }
          item.html = text.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#760EA4">$1</span>');
        }else if(!item.body&&item.attach&&JSON.parse(item.attach)&&JSON.parse(item.attach).type==25 && JSON.parse(item.attach).data && JSON.parse(item.attach).data.append
          &&JSON.parse(JSON.parse(item.attach).data.append).problemType == 'dtb-address'){
          let text = `异常地址：${$this.keyWord}`
          item.html = text.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#760EA4">$1</span>');
        }else if(!item.body&&item.attach&&JSON.parse(item.attach)&&JSON.parse(item.attach).type==25){
          let text = `问题件：${$this.keyWord}`
          item.html = text.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#760EA4">$1</span>');
        }else if(!item.body&&item.attach&&JSON.parse(item.attach)&&JSON.parse(item.attach).type==10){
          let text = JSON.parse(item.attach).data.msgContent
          item.html = text.replace(new RegExp('(' + $this.keyWord + ')', 'g'), '<span style="color:#760EA4">$1</span>');
        }
      });
      $this.searchedData = arr;
    },
    viewDetail: function(item){
      this.$emit("dragHistoryBox",item);
      console.log('viewDetail',item);
    },
    getUsers:function(userIds){
        let $this = this;
        $this.im.getUsers({
            accounts: userIds,
            done: function(error, user){
                console.log("error, user11",error, user);
                if(!error){
                    $this.setToName(user,"p2p","nick","account");
                }
            }
        });
    },
    closeHistoryRecord:function(){
        this.$emit("closeHistoryRecord")
    },
    processHtml:function(){

    },
    enterChatRoom:function(){
        let $this = this;
        $this.$emit("enterChatRoom",$this.recordDetail[0]);
    },
    selectedHistoryRecord:function(){
      this.searchedData[0].selectedHistoryRecord = true;
      this.$emit("dragHistoryBox",this.searchedData[0]);
    },
    /**
     * 
     * @param {时间戳} timestamp 
     * @param {类型} type type==0,如果是当天的 返回今天，type == 1,如果是今天 返回具体时间
     */
    format: function (timestamp,type) {
        //time是整数，否则要parseInt转换
        var time = new Date(timestamp),
          nowDate = new Date(),
          y = time.getFullYear(),
          m = time.getMonth() + 1,
          d = time.getDate(),
          h = time.getHours(),
          mm = time.getMinutes(),
          s = time.getSeconds();
        if (y + "" + m + "" + d + "" == nowDate.getFullYear()+""+(nowDate.getMonth()+1)+""+nowDate.getDate()) {
          if(type == 0){
            return "今天"
          }else if(type == 1){
            return this.add(h) + ':' + this.add(mm) + ':' + this.add(s)
          }
        }
        return y + '-' + this.add(m) + '-' + this.add(d);
    },
    add: function (m) {
      return m < 10 ? '0' + m : m
    }
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    },
    historyRecord:function(arr){
      console.log('historyRecord',arr);
        let $this = this;
        $this.historyRecordData = [];
        if(arr.length == 0) {
            $this.noData = true;
            $this.searchedData = [];
            return;
        };
        $this.noData = false;
        $this.group(arr)
        // $this.getToName();
    }
  }
}
</script>
